import * as React from 'react';
import { View, Platform } from 'react-native';
import { Input, Icon } from 'react-native-elements';
import OrderContext from 'contexts/OrderContext';
import InputSearchProps from 'types/components/InputSearchProps';
import { styles } from 'styles/components/inputSearch';

export default ({ value, handleSearch, setInput, isMediumScreen, placeholderText, keyboardType }: InputSearchProps) => {
  const { currentVenue } = React.useContext(OrderContext);
  const handleChange = (e: any) => {
    setInput(e.nativeEvent.text);
  };

  const handleEnter = (e: any) => {
    if (e.code === 'Enter') handleSearch(e);
  };

  return (
    <View
      style={[
        isMediumScreen ? styles.containerLarge : styles.containerSmall,
        { borderColor: currentVenue?.appColor ?? '#000000' },
      ]}
    >
      <Input
        style={[styles.input, Platform.OS === 'web' && { fontSize: 14 }]}
        inputStyle={Platform.OS === 'web' ? ({ outlineStyle: 'none' } as any) : {}}
        placeholder={placeholderText}
        onChange={handleChange}
        onKeyPress={handleEnter}
        value={value}
        containerStyle={{}}
        inputContainerStyle={{ borderBottomWidth: 0, borderWidth: 0, borderColor: 'transparent' }}
        keyboardType={keyboardType ?? 'default'}
        placeholderTextColor="#979797"
        rightIcon={
          <Icon
            name="search"
            type="ionicon"
            color="#49454F"
            containerStyle={styles.button}
            onPress={handleSearch}
          />
        }
      />
    </View>
  );
};
